module.exports = __webpack_public_path__ + "img/tesf.14c646fd.gif";